import {useController, useFormContext} from "react-hook-form";
import {theme} from "Theme";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Checkbox from "@mui/material/Checkbox";

const FormCheckbox = ({
    name: propsName,
    label = "",
    rules = {},
    disabled = false,
    onChange = null,
    style = {},
}) => {
    const {control} = useFormContext();

    const {
        field,
        fieldState: {error},
    } = useController({
        name: propsName,
        control,
        rules: {
            ...rules,
        },
    });

    const handleChange = (userValue, event) => {
        onChange(userValue, event);
    };

    const labelStyle = {
        "& .MuiFormControlLabel-label": {
            fontSize: theme.typography.fontSize,
        },
    };

    return (
        <FormControl
            error={Boolean(error)}
            margin="none"
            sx={label ? {pl: 1, py: "13px"} : {}}
        >
            <FormControlLabel
                label={label || null}
                name={field.name}
                inputRef={field.ref}
                value={field.value}
                sx={!label ? {m: 0, ...labelStyle} : labelStyle}
                control={
                    <Checkbox
                        checked={!!field.value}
                        onChange={event => {
                            const userValue = event.target.checked;
                            field.onChange(userValue); // data sent back to hook form
                            if (onChange) {
                                handleChange(userValue, event);
                            }
                        }}
                        disabled={disabled}
                        sx={style}
                    />
                }
            />
            {error?.message ? <FormHelperText>{error?.message}</FormHelperText> : null}
        </FormControl>
    );
};

export default FormCheckbox;
